import { Button, CardBody, Container, Row } from "reactstrap";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import { Card, Col, Table } from "reactstrap";
import RequirementTable from "../Tables/ReactStrapTables/BasicTables/RequirementTable/HoverableRowsClass";
import TicketList from "../MISCELLANEOUS/Stats/TicketList";
import { Fragment, useState } from "react";
import CommonButtonsToolTip from "../Buttons/CommonButtons/CommonButtonsToolTip";
import { buttons } from "./buttons";
import LargeModal from "../Tables/ReactStrapTables/BasicTables/RequirementTable/LargeModal";

const Requirement = () => {
  return (
    <>
      <Container className="basic_table" fluid>
        <Card>
          <CardBody>
            <Breadcrumbs
              mainTitle={"Requirements"}
              parent={"Requirement"}
              title={"Table"}
            />

            <TicketList />
          </CardBody>
        </Card>
        {/* <Row></Row> */}
        <CardBody>
          <Card>
            <CardBody>
              <div className="btn-showcase">
                {buttons.map((data, index) => (
                  <Fragment key={index}>
                    <Button
                      className={`btn-pill ${
                        "raised" && `btn-air-${data.color}`
                      }`}
                      active={data.active}
                      disabled={data.disabled}
                      size={data.size ? data.size : ""}
                      id={data.id}
                      color={data.color}
                    >
                      {data.tittle}
                    </Button>
                    <CommonButtonsToolTip
                      toolTipText={data.toolTipText ? data.toolTipText : ""}
                      id={data.id ? data.id : ""}
                    />
                  </Fragment>
                ))}
              </div>
            </CardBody>
            <RequirementTable />
          </Card>
        </CardBody>
      </Container>
    </>
  );
};

export default Requirement;
